import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { useTranslation } from 'react-i18next';

import PropTypes from 'prop-types';

export default function TechnicianFields({
  technicians,
  isLoading,
  formatIndex,
  formatFullname,
  formatGender,
  formatResearcherOrganization,
}) {
  // #region Data
  const { t } = useTranslation();
  // #endregion Data

  return (
    technicians?.length > 0 && (
      <>
        <h4>{t('projectProposal.general.researchHumanResources.technicianFields.label')}</h4>
        <div className="grid">
          <div className="col-12">
            <DataTable
              value={technicians}
              className="p-datatable-gridlines"
              showGridlines
              dataKey="contact.id"
              loading={isLoading}
              responsiveLayout="scroll"
            >
              <Column
                header={t('formLayout.numericalOrder')}
                body={formatIndex}
                style={{ textAlign: 'center', width: '5%' }}
              />
              <Column
                header={`${t(
                  'projectProposal.general.researchHumanResources.fields.academicRank'
                )}, ${t(
                  'projectProposal.general.researchHumanResources.fields.academicDegree'
                )}, ${t('projectProposal.general.researchHumanResources.fields.name')}`}
                body={formatFullname}
                style={{ minWidth: 100, width: '22%' }}
              />
              <Column
                header={t('projectProposal.general.researchHumanResources.fields.gender')}
                body={formatGender}
                style={{ minWidth: 100, width: '5%' }}
              />
              <Column
                body={formatResearcherOrganization}
                header={t('projectProposal.general.researchHumanResources.fields.organization')}
                style={{ minWidth: 200, width: '28%' }}
              />
            </DataTable>
          </div>
        </div>
      </>
    )
  );
}

TechnicianFields.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  technicians: PropTypes.array.isRequired,
  isLoading: PropTypes.bool.isRequired,
  formatIndex: PropTypes.func.isRequired,
  formatFullname: PropTypes.func.isRequired,
  formatGender: PropTypes.func.isRequired,
  formatResearcherOrganization: PropTypes.func.isRequired,
};
